const handleCellVideoSound = (videoContainer) => {
    const video = videoContainer.querySelector('.project-highlight__video');
    const soundButton = videoContainer.querySelector('.project-highlight__phone--sound');

    soundButton.addEventListener("click", (e) => {
        if (video.muted) {
            video.muted = false;
            soundButton.classList.remove('sound-inactive');
        } else {
            video.muted = true;
            soundButton.classList.add('sound-inactive');
        }
    })
}

export { handleCellVideoSound };